// src/config/sourceMap.js
const SOURCE_MAP = {
  wayuvega: {
    id: "wayuvega",
    title: "Wayuvega",
    pageTitle: "Wayuvega - Logistics & Delivery",
    logo: "/logo.png",
    favicon: "/logo.png",
    appleTouchIcon: "/logo.png",
    manifest: "/manifest.json",
    tagline: "Delivering Trust, Always!",
    headerGradient: "linear-gradient(90deg,#ffffff,#e6f0ff)",
    avatarGradient: "linear-gradient(135deg,#3b82f6,#2563eb)",
    textColor: "text-blue-600",
    textColorValue: "#1e40af",
    cardBackground: "#ffffff",
    accentColor: "#3b82f6",
    themeColor: "#e6f0ff",
    loginRoute: "/login",
    // add domains that should cause this branding
    domains: ["merchant.wayuvega.in", "localhost", "127.0.0.1"],
  },
  jumbomail: {
    id: "jumbomail",
    title: "Jumbo Mail",
    pageTitle: "Jumbo Mail",
    logo: "/jumbo_mail_logo.jpeg",
    favicon: "/jumbo_mail_logo.jpeg",
    appleTouchIcon: "/jumbo_mail_logo.jpeg",
    manifest: "/manifest-jumbo.json",
    tagline: "Fast, secure mail & shipment service.",
    headerGradient: "linear-gradient(90deg,#fffaf5,#f1efe8)",
    avatarGradient: "linear-gradient(135deg,#2A8FD3,#0b5566)",
    textColor: "text-[#07374a]",
    textColorValue: "#07374a",
    cardBackground: "#ffffff",
    accentColor: "#2A8FD3",
    themeColor: "#fffaf5",
    loginRoute: "/login-jumbo",
    domains: ["merchant.jumbopost.in", "jumbopost.local"],
  },
};

export default SOURCE_MAP;
